var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1B5FC2;}\r\n\t.st1{opacity:0.2;}\r\n\t.st2{fill:#231F20;}\r\n\t.st3{fill:#4F5D73;}\r\n\t.st4{fill:#F5CF87;}\r\n\t.st5{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 32,
    r: 32
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.9,46.2L35.8,32.1c-1-1-2.5-1.4-3.8-1l-8.1-8l-3-5.9l-5.9-3L12.1,17l3,5.9l5.9,3l0,0l8.1,8 c-0.4,1.3,0,2.8,1,3.8l14.1,14.1c1.6,1.6,4.1,1.6,5.7,0C51.5,50.3,51.5,47.8,49.9,46.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "34.5,37.3 18.4,21.4 21.3,18.6 37.4,34.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.9,49.9c-1.6,1.6-4.1,1.6-5.7,0L30.1,35.8c-1.6-1.6-1.6-4.1,0-5.7l0,0c1.6-1.6,4.1-1.6,5.7,0l14.1,14.1 C51.5,45.8,51.5,48.3,49.9,49.9L49.9,49.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.3,18.4l-6.5,6.5c-1.6,1.6-4.1,1.6-5.7,0c-1.6-1.6-1.6-4.1,0-5.7l6.5-6.5C46.5,12.3,45.3,12,44,12 c-5.5,0-10,4.5-10,10c0,1.3,0.3,2.5,0.7,3.6l-11,11C22.5,36.3,21.3,36,20,36c-5.5,0-10,4.5-10,10c0,1.3,0.3,2.5,0.7,3.6l6.5-6.5 c1.6-1.6,4.1-1.6,5.7,0c1.6,1.6,1.6,4.1,0,5.7l-6.5,6.5c1.1,0.4,2.4,0.7,3.6,0.7c5.5,0,10-4.5,10-10c0-1.3-0.3-2.5-0.7-3.6l11-11 c1.1,0.4,2.4,0.7,3.6,0.7c5.5,0,10-4.5,10-10C54,20.7,53.7,19.5,53.3,18.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 28,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -13.2548 32)",
    className: "st5",
    width: 17.1,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "21,23.9 15.1,20.9 12.1,15 14.9,12.1 20.8,15.2 23.9,21.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.8,22.8c-1.6,1.6-4.1,1.6-5.7,0c-1.6-1.6-1.6-4.1,0-5.7l6.5-6.5C46.5,10.3,45.3,10,44,10 c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10s10-4.5,10-10c0-1.3-0.3-2.5-0.7-3.6L46.8,22.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M17.2,41.2c1.6-1.6,4.1-1.6,5.7,0c1.6,1.6,1.6,4.1,0,5.7l-6.5,6.5c1.1,0.4,2.4,0.7,3.6,0.7 c5.5,0,10-4.5,10-10c0-5.5-4.5-10-10-10s-10,4.5-10,10c0,1.3,0.3,2.5,0.7,3.6L17.2,41.2z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTools);
export default __webpack_public_path__ + "static/media/LogoTools.01bcbd64b5871ef4e76c9ba3aa82469b.svg";
export { ForwardRef as ReactComponent };